export default {"src":"/_next/static/media/npci.dcc1a3ab.svg","height":33,"width":97,"blurWidth":0,"blurHeight":0};